import posthog, { type CaptureOptions, type Properties } from 'posthog-js'

type PostHogConfig = {
  apiHost: string
  projectToken: string
}

let customerType: string | undefined

export function initialisePostHog(
  { projectToken, apiHost }: PostHogConfig,
  distinctId: string,
  studentCustomerType: string,
) {
  customerType = studentCustomerType.toLowerCase()

  posthog.init(projectToken, {
    api_host: apiHost,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_performance: false,
    advanced_disable_flags: true,
    bootstrap: {
      distinctID: distinctId,
      isIdentifiedID: true,
    },
  })
}

export function capture(event: string, customProperties?: Properties, options?: CaptureOptions) {
  const properties = { application: 'msp', ...customProperties }

  posthog.capture(event, properties, {
    ...options,
    $set: {
      customer_type: customerType,
      ...options?.$set,
    },
  })
}

export function trackPageview() {
  capture('$pageview')
}
